<template>
  <section class="payment_sec h-100" v-show="!loader">
    <div class="container h-100">
      <iframe name="ddc-iframe" v-show="false">
      </iframe>
      <form ref="ddc_device" id="ddc-form" target="ddc-iframe" method="POST" :action="deviceActionUrl">
        <input type="hidden" name="JWT" v-model="deviceJwt"/>
      </form>

      <!--            <iframe name="step-up-iframe" ></iframe>-->
      <form ref="ddc_link" id="step-up-form" target="_self" method="post" :action="linkActionUrl"><input
        type="hidden" name="JWT"
        v-model="linkJwt"/>
        <input type="hidden" name="MD" value=""/></form>
    </div>
  </section>
  <div v-show="loader" class="blockUI" style="display:none"></div>
  <div v-show="loader" class="blockUI blockOverlay"
       v-bind:style="{ 'background-image': 'url(' + image + ')'  }"
       style="z-index: 1000; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-size: cover; cursor: wait; position: fixed;"></div>
  <div v-show="loader" class="blockUI blockMsg blockPage"
       style="z-index: 1011; position: fixed; padding: 0px; margin: 0px; width: 40%; top: 40%; left: 30%; text-align: center; color: rgb(255, 255, 255); border: 0px; background-color: transparent; cursor: wait;">
    <div class="d-flex justify-content-center align-items-center">
      <img :src="`${publicPath}images/logo.svg`">
      <p class="mr-50 mb-0" style="color:#316992">Please wait your request is being processed...</p>
      <div class="spinner-border spinner-border-sm " style="color:#316992" role="status"></div>
    </div>
  </div>
  <div ref="dForm" id="aa" v-html="myForm"></div>
  <div v-if="triggerIframe" ref="iframeHtml" id="iframeHtml" v-html="iframeHtml"></div>
</template>

<script>
import axios from 'axios';

export default {
  components: {
    axios
  },
  mounted() {

    this.txnId = typeof (this.$route.query.txnId) != 'undefined' ? this.$route.query.txnId : ''
    this.sessionId = typeof (this.$route.query.sessId) != 'undefined' ? this.$route.query.sessId : ''
    this.getTransactionLink()

    window.addEventListener("message", (event) => {

      if (event.origin === this.originUrl) {
        this.waiting = false
        // var data = JSON.parse(event.data);
        this.loader = false
        console.log('Device collection completed:');

        this.getTransactionLink(false)

      }

    }, false);




  },
  data() {
    return {
      myForm:'',
      txnId: '',
      sessionId: '',
      loader: true,
      deviceActionUrl: '',
      deviceJwt: '',
      linkActionUrl: '',
      linkJwt: '',
      image: this.publicPath + 'images/bac1.jpg',
      waiting:false,
      originUrl:'',
      iframeHtml: '',
      triggerIframe: false
    }
  },
  methods: {
    removeIframeTarget(res) {
      // Remove the iframe and set target to _self (same window)
      let temp = res
      temp = temp.replace('target="challengeFrame"', 'target="_self"')
      temp = temp.replace('target="redirectTo3ds1Frame"', 'target="_self"')
      return temp
    },
    extractAndExecuteScript(res) {
      // Extract the script from the API response
      const scriptMatch = res.match(/<script[^>]*>([\s\S]*?)<\/script>/);
      if (scriptMatch && scriptMatch[1]) {
        const scriptContent = scriptMatch[1];

        // Create a new script element and append it to the document body
        this.$nextTick(() => {
          const scriptElement = document.createElement('script');
          scriptElement.text = scriptContent;
          document.body.appendChild(scriptElement);
        })
      }
    },
    getTransactionLink(deviceCollection = true) {
      let data = {}
      if(this.sessionId != ''){
        data.sessionId = this.sessionId
      }else{
        data.transactionId = this.txnId
      }
      // data.transactionId = this.txnId
      if (deviceCollection) {
        data.deviceCollection = 1
      }
      this.loader = true
      this.makeRequest('post', 'v1/transaction-url-details', data, {}, false).then(callResponse => {


        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data


            if (data) {
              if (this.sessionId != '') {
                this.myForm = atob(data)

                this.$nextTick(() => {
                  document.getElementById('aa').firstElementChild.submit()

                });

                return
              }

              if (deviceCollection) {
                /*this will run when device collection param is passed*/

                if(typeof data.iframeHtml != 'undefined'){

                  this.iframeHtml = this.removeIframeTarget(atob(data.iframeHtml))
                  // this.iframeHtml = atob(data.iframeHtml)
                  this.triggerIframe = true
                  this.extractAndExecuteScript(this.iframeHtml)
                  return;
                }

                this.originUrl = data.deviceFormUrl
                let device = data.deviceCollectionDetails
                this.deviceActionUrl = device.url
                this.deviceJwt = device.token

                let scriptUrl = device.fingerPrintDetails
                const plugin = document.createElement("script");
                plugin.setAttribute(
                  "src",
                  scriptUrl
                );
                plugin.setAttribute(
                  "type",
                  'text/javascript'
                );
                document.body.appendChild(plugin);


                // let ab = new FormData();
                // ab.append("JWT", 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1MGMzNTA1MS04MjE5LTRmYzItYWFlZi1lNThmZDJiZTA5ZWUiLCJpYXQiOjE2MzIzMDI1MjcsImlzcyI6IjVkZDgzYmYwMGU0MjNkMTQ5OGRjYmFjYSIsImV4cCI6MTYzMjMwNjEyNywiT3JnVW5pdElkIjoiNWI5YzRiYjNmZjYyNmIxMzQ0ODEwYTAxIiwiUmVmZXJlbmNlSWQiOiIxODdhMzZjMC00YzdlLTRlMTAtYmJlNi1kMzQ1YmYxMDRiYTAifQ.OB2HUf2R78OEyJi7R-l3ZFOWefefCWSIcBVK6fK_Qnk');
                //
                //
                // axios.post('https://centinelapistag.cardinalcommerce.com/V1/Cruise/Collect', ab).then(callResponse => {
                //     console.log(callResponse,'ssssssssssssssssssss')
                // })

                this.$nextTick(() => {
                  this.waiting = true
                  this.$refs.ddc_device.submit()
                  setTimeout(()=>{
                    if(this.waiting){
                      localStorage.setItem('errorMessage', 'Error! An error occurred');
                      this.loader = false
                      this.$router.push({name: 'payment-failed'})
                      return
                    }


                  },60000)

                });
              } else {
                /*this will run when device collection param is not passed*/



                if (data.bypass3DS) {
                  /*if bypass 3ds == true show success page directly*/
                  localStorage.setItem('transaction-payment-details',JSON.stringify(data));
                  this.$router.replace({name: 'payment-success', query: {txnId: data.transactionId}})
                } else {

                  let verification = data.verification
                  this.linkActionUrl = verification.url
                  this.linkJwt = verification.token


                  if (this.linkActionUrl && this.linkJwt) {

                    this.$nextTick(() => {

                      this.$refs.ddc_link.submit()
                    });

                  } else {
                    localStorage.setItem('errorMessage', 'There seems to be a problem. Please try again later ');
                    this.$router.push({name: 'payment-failed'})
                  }

                }
              }


            } else {
              localStorage.setItem('errorMessage', 'There seems to be a problem. Please try again later ');
              this.$router.push({name: 'payment-failed'})
            }


          }
        }

      });
    },
  }
}
</script>

<style scoped>
.gryColor {
  color: gray !important;
}


</style>


